import { get, post, remove, update } from '@apis/api';
import { CommonResponse } from '@wconcept/wconcept-common/models/common-response';
import { ShopLiveListResponse } from '@wconcept/wconcept-common/models/renewal/shoplive';

const baseURL = process.env.NEXT_PUBLIC_DISPLAY_API_GATEWAY_URL;
const options = {
  headers: {
    'Content-Type': 'application/json; charset=utf-8', // 필요에 따라 헤더 수정
    'DISPLAY-API-KEY': process.env.NEXT_PUBLIC_DISPLAY_API_GATEWAY_KEY || '',
  },
};

// /display/api/shoplive/v1/register
export const reuestRegisterShopLiveAlarmTalk = async ({
  campaignKey,
}: {
  campaignKey: string;
}) => {
  const res = await post<CommonResponse<ShopLiveListResponse>>({
    url: `/display/api/shoplive/v1/alarmTalk`,
    baseUrl: baseURL,
    options,
    data: {
      campaignKey,
    },
  });
  return res;
};

export const reuestUnregisterShopLiveAlarmTalk = async ({
  campaignKey,
}: {
  campaignKey: string;
}) => {
  const res = await remove<CommonResponse<boolean>>({
    url: `/display/api/shoplive/v1/alarmTalk?campaignKey=${campaignKey}`,
    baseUrl: baseURL,
    options,
  });
  return res;
};

// /display/api/shoplive/v1/alarmTalk/confirm
export const requestConfirmShopLiveAlarmTalk = async () => {
  const res = await get<CommonResponse<boolean>>({
    url: `/display/api/shoplive/v1/alarmTalk/confirm`,
    baseUrl: baseURL,
    options,
  });
  return res;
};

// /display/api/shoplive/v1/alarmTalk/status
// 샵 라이브 알림 설정 여부 조회 API
export const requestGetShopLiveAlarmStatus = async ({
  campaignKey,
}: {
  campaignKey: string;
}) => {
  const res = await get<CommonResponse<boolean>>({
    url: `/display/api/shoplive/v1/alarmTalk/status?campaignKey=${campaignKey}`,
    baseUrl: baseURL,
    options,
  });
  return res;
};
